import React from 'react';
import { DispensingSearch } from '../../DispensingSearch/DispensingSearch';
import { DmsAltBox, DmsTextField } from 'dmsbasereact';
import { DmsAutocomplete } from '../../DmsAutoComplete/DmsAutoComplete';
import { Box, Typography } from '@mui/material';

export const TreatmentDiscontinuationContainer = ({
    searchedDispensings,
    setSearchedDispensings,
    dispensings,
    data,
    handleChange,
    fieldHasError,
    helperText,
    intl,
    batches = [],
}) => {

    const dispensingSearchContainer = (
        <DmsAltBox.Card>
            <DmsAltBox.Header>
                <Typography variant="h6">
                    {intl.get("SearchDispensing").d("Search Dispensing")}
                </Typography>
            </DmsAltBox.Header>
            <DmsAltBox.Body>
                <DispensingSearch onDispensingsFound={setSearchedDispensings} />

                {searchedDispensings.length > 0 && (
                    <Box sx={{ mt: 2 }}>
                        <DmsAutocomplete
                            label={intl.get("SelectDispensing").d("Select Dispensing") + " *"}
                            key={`dispensing-${dispensings.length}`}
                            name="dispensing_pk"
                            value={data.dispensing_pk}
                            onChange={(value) => handleChange({ target: { name: "dispensing_pk", value } })}
                            options={searchedDispensings.map(disp => ({
                                value: disp.pk,
                                label: `${disp.patient_name} | ${disp.prescription_identifier} | ${disp.capsule_count} ${intl.get("Capsules").d("capsules")} | ${disp.box_count} ${intl.get("Boxes").d("boxes")} | ${disp.batch_number}`
                            }))}
                            fullWidth
                            error={fieldHasError("dispensing_pk")}
                            helperText={helperText("dispensing_pk")}
                        />
                    </Box>
                )}
            </DmsAltBox.Body>
        </DmsAltBox.Card>
    );

    const formatDate = (date) => {
        if (!date) return '-';
        try {
            return new Date(date).toLocaleDateString('pt-BR');
        } catch {
            return '-';
        }
    };

    const returnDetailsContainer = (
        <DmsAltBox.Card>
            <DmsAltBox.Header>
                <Typography variant="h6">
                    {intl.get("returnDetails").d("Return Details")}
                </Typography>
            </DmsAltBox.Header>
            <DmsAltBox.Body>
                <Box sx={{ mt: 2 }}>
                    <DmsAutocomplete
                        label={intl.get("Batch").d("Batch") + " *"}
                        key={`batch-treatment-${batches.length}`}
                        name="batch_pk"
                        value={data.batch_pk}
                        onChange={(value) => handleChange({ target: { name: "batch_pk", value } })}
                        options={batches.map(batch => ({
                            value: batch.pk,
                            label: `${intl.get("Batch").d("Batch")}: ${batch.number || '-'} | ${intl.get("Part").d("Part")}: ${batch.part_name || batch.part?.name || '-'} | ${intl.get("Quantity").d("Quantity")}: ${batch.quantity || 0} | ${intl.get("Fabrication").d("Fabrication")}: ${formatDate(batch.fabrication)}`
                        }))}
                        fullWidth
                        error={fieldHasError("batch_pk")}
                        helperText={helperText("batch_pk")}
                    />
                </Box>
                <Box sx={{ mt: 2 }}>
                    <DmsTextField
                        label={intl.get("QuantityOfBoxesToReturn").d("Quantity of Boxes to Return") + " *"}
                        name="quantity"
                        type="number"
                        value={data.quantity}
                        onChange={handleChange}
                        fullWidth
                        error={fieldHasError("quantity")}
                        helperText={helperText("quantity")}
                    />
                </Box>
            </DmsAltBox.Body>
        </DmsAltBox.Card>
    );

    return (
        <>
            {dispensingSearchContainer}
            {returnDetailsContainer}
        </>
    );
};
